// ---------------------------------------------- modules import
import React, { FunctionComponent } from "react";
import { Redirect } from "react-router-dom";

import Details from "./details";
import ResetPassword from "./resetPassword";
import UpdateTheme from "./updateTheme";

import { IUserSettingsPorps } from "./common";
import { useAuth, useToggle, useUser } from "./hooks";

// ---------------------------------------------- the component
const UserSettings: FunctionComponent<IUserSettingsPorps> = ({ menuIndex }) => {
  // ---------------------------------------------- local state
  const { auth, profile, areLoaded, isEmptied } = useAuth();
  const {
    user,
    isNewPasswordValid,
    onChange,
    onChangePassword,
    onUpdate,
    onUpdatePassword
  } = useUser(menuIndex, auth.uid);
  const {
    isThemeReady,
    isResetReady,
    onToggleTheme,
    onToggleReset
  } = useToggle();

  // ---------------------------------------------- content
  return !areLoaded ? null : isEmptied ? (
    <Redirect to="/login" />
  ) : (
    <div className="container row">
      <Details
        user={user}
        onToggleTheme={onToggleTheme}
        onToggleReset={onToggleReset}
      />

      {isThemeReady ? (
        <UpdateTheme
          profile={profile}
          onChange={onChange}
          onUpdate={onUpdate}
        />
      ) : null}

      {isResetReady ? (
        <ResetPassword
          profile={profile}
          isNewPasswordValid={isNewPasswordValid}
          onChangePassword={onChangePassword}
          onUpdatePassword={onUpdatePassword}
        />
      ) : null}
    </div>
  );
};

export default UserSettings;
